'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscSecurity = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M3 2v2h16v6c0 4.81-1.97 7.76-7 10.38C6.97 17.76 5 14.81 5 10V6H3v4c0 7.46 4.63 10.43 9 12.62 4.38-2.19 9-5.16 9-12.62V2H3Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m15.29 7.79-3.79 3.8-1.79-1.8-1.42 1.42 3.21 3.2 5.21-5.2-1.42-1.42Z" })
);

module.exports = SvgMiscSecurity;
//# sourceMappingURL=MiscSecurity.cjs.js.map
